export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Al finalizar la compra recibirás un enlace de descarga inmediata en tu correo electrónico. Accede al instante desde cualquier dispositivo, sin esperas ni envíos físicos.'
  },
  {
    q: '¿Es seguro el pago?',
    a: 'Sí. El pago se procesa a través de plataformas certificadas con encriptación SSL. Tus datos están completamente protegidos.'
  },
  {
    q: '¿Es un solo pago?',
    a: 'Sí. Pagas una sola vez y el acceso es de por vida. Sin suscripciones, sin pagos mensuales ni sorpresas.'
  },
  {
    q: '¿En qué moneda se realiza el pago?',
    a: 'El precio se muestra en euros. Las opciones de moneda y pago disponibles se indican durante el proceso de compra.'
  },
  {
    q: '¿Puedo utilizar MISTER PRO si entreno fuera de España?',
    a: 'Sí. MISTER PRO es un sistema digital en español pensado para entrenadores de fútbol que necesitan organizar sus sesiones y contar con recursos para trabajar con sus equipos. Puedes adaptar los ejercicios, las progresiones y la planificación al nivel de tus jugadores, las categorías de tu club y el calendario de competición de tu país.'
  },
  {
    q: '¿El producto incluye videos o clases grabadas?',
    a: 'No. Es una colección de materiales digitales con sesiones, ejercicios, diagramas y recursos de planificación.'
  },
  {
    q: '¿Sirve para entrenadores con poca experiencia?',
    a: 'Completamente. El sistema está diseñado para entrenadores de todos los niveles. Si llevas 10 años en la zona técnica encontrarás profundidad táctica. Si eres nuevo encontrarás estructura y seguridad desde el primer día.'
  },
  {
    q: '¿Puedo usarlo solo para una categoría concreta?',
    a: 'Sí. Aunque el sistema cubre desde Benjamín hasta Regional/Amateur, cada tomo indica claramente las adaptaciones por categoría. Puedes ir directamente a lo que necesitas.'
  },
  {
    q: '¿Qué pasa si tengo jugadores de distintos niveles en el mismo equipo?',
    a: 'Cada ficha indica los jugadores, el espacio y los ajustes recomendados: consulta esa información para elegir la propuesta adecuada al nivel de tus jugadores. El sistema está pensado para la realidad del fútbol formativo, donde casi siempre hay niveles mezclados.'
  },
  {
    q: '¿En qué formato vienen los archivos?',
    a: 'Todo en PDF de alta calidad, optimizado para pantalla y para imprimir en A4. Compatible con móvil, tablet y computadora.'
  },
  {
    q: '¿Tiene garantía de devolución?',
    a: 'Sí. Garantía de 7 días: si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo recibido no corresponde con la oferta mostrada en esta página, escríbenos a manualeslistos@gmail.com y lo resolveremos.'
  }
];
